// import './style.scss';
import React from 'react';
import { modalStore } from '~/mobx/modalStore';
import ScrollableBlock from '~/view/containers/ScrollableBlock/ScrollableBlock';
// eslint-disable-next-line max-len
import T360BranchesMappingTableRow from '~/view/screens/SettingsScreen/screens/Integrations/Integrations/components/T360BranchesMapping/T360BranchesMappingTableRow/T360BranchesMappingTableRow';
import { IBranch } from '~/types/branches';
import { getTranslate } from '~/utils/helpers';

const T360BranchesMappingTableBody: React.FC = () => {
  const { t360BranchesMappingModal } = modalStore;

  const sortBranches = (branch1: IBranch, branch2: IBranch): number => {
    const first = getTranslate(branch1.name);
    const second = getTranslate(branch2.name);

    if (first > second) {
      return 1;
    } else if (first < second) {
      return -1;
    }
    return 0;
  };

  return (
    <ScrollableBlock showScrollbar scrollClassName="d-flex flex-column full-height px-8" className="flex-1 mb-3">
      {t360BranchesMappingModal?.takerBranches.sort(sortBranches).map((takerBranch) => (
        <T360BranchesMappingTableRow
          key={`mapping-taker-branch-${takerBranch.id}`}
          takerBranch={takerBranch}
          branchesMapping={t360BranchesMappingModal?.mappedBranches}
        />
      ))}
    </ScrollableBlock>
  );
};

export default T360BranchesMappingTableBody;
